import {
  useStyle
} from "@/classify"
import {
  usePagination
} from "@/hooks/Pagination/usePagination"
import Link from "next/link"
import Ellipsis from "./ellipsis"
import defaultClasses from "./pagination.module.css"
import Tile from "./tile"

const Pagination = (props) => {
  const {
    afterClick = () => {},
    mode = "button",
    generateHref
  } = props || {}
  const {
    currentPage, setPage, totalPages 
  } = props.pageControl

  const classes = useStyle(defaultClasses, props.classes)

  const talonProps = usePagination({
    currentPage,
    setPage,
    totalPages,
    afterClick,
  })

  const {
    handleNavBack,
    handleNavForward,
    isActiveLeft,
    isActiveRight,
    tiles,
  } = talonProps

  const navigationTiles = tiles.map((tileNumber) => {
    if (tileNumber === "previous") {
      if (mode === "button" || currentPage <= 1) {
        return (
          <div
            className={
              isActiveLeft
                ? classes.navBackButtonActive
                : classes.navBackButton
            }
            key={tileNumber}
            onClick={handleNavBack}
          />
        )
      }

      if (mode === "link") {
        return <Link 
          className={
            isActiveLeft
              ? classes.navBackButtonActive
              : classes.navBackButton
          }
          href={generateHref?.(currentPage - 1)}
          key={tileNumber}
          onClick={handleNavBack} 
        />;
      }

      return null
    } 
    
    if (tileNumber === "next") {
      if (mode === "button" || currentPage >= totalPages) {
        return (
          <div
            className={
              isActiveRight
                ? classes.nextButtonActive
                : classes.nextButton
            }
            key={tileNumber}
            onClick={handleNavForward}
          />
        )
      }

      if (mode === "link") {
        return <Link 
          className={
            isActiveRight
              ? classes.nextButtonActive
              : classes.nextButton
          }
          key={tileNumber} 
          href={generateHref?.(currentPage + 1)}
          onClick={handleNavForward}
        />;
      }

      return null;
    } 
    
    if (tileNumber === "start-ellipsis") {
      return <Ellipsis key={tileNumber} />
    } 
    
    if (tileNumber === "end-ellipsis") {
      return <Ellipsis key={tileNumber} />
    }

    return (
      <Tile
        isActive={tileNumber === currentPage}
        key={tileNumber}
        number={tileNumber}
        onClick={setPage}
        afterClick={afterClick}
        mode={mode}
        href={generateHref?.(tileNumber)}
      />
    )
  })

  if (totalPages === 1) {
    return null
  }

  return (
    <div className={classes.root} data-cy='Pagination-root'>
      {navigationTiles}
    </div>
  )
}

export default Pagination
